import { render, staticRenderFns } from "./HomeWelcome.vue?vue&type=template&id=6cebad31"
import script from "./HomeWelcome.vue?vue&type=script&lang=js"
export * from "./HomeWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports